const PERMISSION_RE = /don't have permission|no tiene(?:s|n)? permiso|permission to access/i;

export const attachAuthErrorBody = async (res, fallbackLabel) => {
  const error = new Error(`${fallbackLabel} ${res.status}`);
  error.status = res.status;
  try {
    const body = await res.json();
    error.apiMessage = body?.message ? String(body.message) : '';
    error.apiCode = body?.code ?? body?.status ?? null;
  } catch (e) {
    error.apiMessage = '';
  }
  return error;
};

/** 400/403 from /auth/automy + portalId when the Automy user cannot enter that portal. */
export const isPortalAccessDenied = (error) => {
  if (!error) return false;
  const status = Number(error.status);
  if (status !== 400 && status !== 403) return false;
  return PERMISSION_RE.test(String(error.apiMessage || error.message || ''));
};
